import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=78eca0ce"
var script = {}
import style0 from "./Contents.vue?vue&type=style&index=0&id=78eca0ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports